export class PolicyInfo {

  constructor (
    public CertificateNumber: string, 
    public CustomerName: string, 
    public DealerCode: string, 
    public DealerGroup: string,
    public IdentificationNumber: string, 
    public ItemDescription: string, 
    public Manufacturer: string, 
    public Model: string, 
    public ProductCode: string,
    public ProductDescription: string, 
    public SKUNumber: string, 
    public SerialNumber: string, 
    public ServiceLineNumber: string, 
    public StatusCode: string,
    public WarrantySalesDate: Date, 
    public WorkPhone: string)  {
  }
  
}
